import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useAsyncDebounce, useExpanded, useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import { Row, Table } from 'reactstrap';
import { download_icon, filter_icon, upload_icon } from '../../../assets/images';
import { DefaultColumnFilter, Filter } from '../../../components/Common/filters';
import { SEARCH_QUOTATION_BLANK } from '../../../store/Sales/actiontype';
import { QUOTATION_RESULT_SELECTED_BLANK, SMART_QUOTATION_VALUE_UPDATE } from '../../../store/InstantRate/actionType';
import ReactPaginate from 'react-paginate';
import TableCommonSkeleton from '../../Skeleton/TableCommonSkeleton';
import { getInternalRoute } from '../../../components/Common/CommonLogic';
import Select from "react-select";

// Define a default UI for filtering
function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}) {
    const count = preGlobalFilteredRows.length;
    // console.log(count,"count");
    const [value, setValue] = React.useState(globalFilter);
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined);
    }, 200);

    return (
        <div className="search_form">
            <form>
                <div className="position-relative">
                    <input
                        type="search"
                        onChange={e => {
                            e.preventDefault();
                            setValue(e.target.value);
                            onChange(e.target.value);
                            return false;
                        }}
                        className="form-control"
                        placeholder="Search"
                        value={value || ""}
                    />
                    <button className="btn" type="button">
                        <i className="bx bx-search-alt-2 align-middle"></i>
                    </button>
                </div>
            </form>
        </div>
    );
}

const ViewBidsTable = ({ tableRef, columns, inquiryType, data, isGlobalFilter, customPageSize, downLoadExcelReport, toggleRightCanvas, component, loader, setCurrentPage, totalPages, totalEntries, onClickAssingto, onClickReject }) => {
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state, preGlobalFilteredRows, setGlobalFilter, state: { pageIndex, pageSize }, } = useTable({
        columns,
        data,
        defaultColumn: { Filter: DefaultColumnFilter },
        initialState: { pageIndex: 0, pageSize: customPageSize },
    },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,);
    const navidate = useNavigate();
    const dispatch = useDispatch();
    const { currency_data } = useSelector((state) => state?.globalReducer);
    const { smartQuotationsValues } = useSelector((state) => state.instantRate);
    return (
        <>
            <div className="freight_filter_wrap d-flex align-items-center">
                <p className="label flex-grow-1 m-0">Filters :</p>

                <div className="right_actions_wrap flex-shrink-0 d-flex align-items-center">
                    {isGlobalFilter && (
                        <GlobalFilter
                            preGlobalFilteredRows={preGlobalFilteredRows}
                            globalFilter={state.globalFilter}
                            setGlobalFilter={setGlobalFilter}
                        />
                    )}
                    {inquiryType === "OCEAN_FCL" && (
                        <div className="filter_wrap">
                            <Select
                                name="quote_currency"
                                options={currency_data?.map(({ value, currencyCode, id, version }) => ({
                                    value,
                                    label: currencyCode,
                                    currencyCode,
                                    id,
                                    version,
                                }))}
                                value={smartQuotationsValues?.quote_currency && Object.keys(smartQuotationsValues?.quote_currency).length > 0 ? smartQuotationsValues?.quote_currency : 'Select Currency...'}
                                onChange={(selectedOption) => {
                                    console.log(selectedOption, "selectedOption");
                                    dispatch({
                                        type: SMART_QUOTATION_VALUE_UPDATE,
                                        payload: { quote_currency: selectedOption },
                                    });
                                }}
                                classNamePrefix="react-select"
                                styles={{ container: base => ({ ...base, minWidth: '80px' }) }}
                            />
                        </div>
                    )}

                    <div className="filter_wrap">
                        <button className='bg-transparent' onClick={toggleRightCanvas}><img src={filter_icon} alt="filter" /></button>
                    </div>
                    {component !== 'inquiry' && component != 'requestForRate' && (
                        <>
                            {/* <div className="upload_wrap">
                                <button className='bg-transparent'>
                                    <img src={upload_icon} alt="Upload" />Upload file
                                </button>
                            </div> */}
                            {/* <div className="add_btn">
                                <button className='border-0' onClick={() => {navidate('/sales/create');dispatch({type: SEARCH_QUOTATION_BLANK});dispatch({type: QUOTATION_RESULT_SELECTED_BLANK});}}>
                                    <i className='bx bx-plus align-middle'></i> Instant Rate
                                </button>
                            </div> */}
                        </>
                    )}
                    {component == 'requestForRate' && component == 'inquiry' && <div className="add_btn">
                        <button className='border-0' onClick={() => { navidate(getInternalRoute("instant-search-rate")); dispatch({ type: SEARCH_QUOTATION_BLANK }); dispatch({ type: QUOTATION_RESULT_SELECTED_BLANK }); }}>
                            <i className='bx bx-plus align-middle'></i> Instant Rate
                        </button>
                    </div>
                    }
                    <>
                        <div className="add_btn">
                            <button className='border-0' onClick={onClickAssingto}>
                                Compare Quotations
                            </button>
                        </div>
                    </>

                    {component === 'quotationApproval' && (
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <div >
                                        <button className="btn btn-danger w-100" onClick={onClickReject}>
                                            Reject
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div >
                                        <button className="border-0 w-100 btn btn-success" onClick={onClickAssingto}>
                                            Approve
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className="table_pagination_wrap">
                <div className="table-responsive table_wrap">
                    <Table ref={tableRef} hover {...getTableProps()} className={'test'}>
                        <thead className="table-light table-nowrap">
                            {headerGroups.map(headerGroup => (
                                <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th key={column.id}>
                                            <span className='d-flex align-items-center'
                                                {...(!column.disableSortBy ? column.getSortByToggleProps() : {})}>
                                                {column.render("Header")}
                                                {!column.disableSortBy && (
                                                    <i
                                                        className={`fas fa-sort ms-1 ${column.isSorted ? (column.isSortedDesc ? "fa-sort-down" : "fa-sort-up") : ""
                                                            }`}
                                                    ></i>
                                                )}
                                            </span>
                                            <Filter column={column} />
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody {...getTableBodyProps()}>
                            {loader ? (
                                <TableCommonSkeleton tdCount={headerGroups[0].headers.length} />
                            ) : (
                                <Fragment>
                                    {page.map((row, index) => {
                                        prepareRow(row);
                                        return (
                                            <Fragment key={row.getRowProps().key}>
                                                <tr style={{ backgroundColor: row?.cells[index]?.row?.original?.statusCode === "Customer Approved" ? "rgb(6 145 6 / 21%)" : "" }}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <>
                                                                <td key={cell.id} {...cell.getCellProps()} style={{ backgroundColor: cell?.row?.original?.is_active === false ? "#D3D3D3" : "" }}>
                                                                    {cell.render("Cell")}
                                                                </td>
                                                            </>
                                                        );
                                                    })}
                                                </tr>
                                                <div style={{ marginBottom: index === page.length - 1 && page.length <= 4 ? '150px' : '0' }}></div>
                                            </Fragment>
                                        );
                                    })}
                                    {page?.length === 0 && (
                                        <tr>
                                            <td colSpan={headerGroups[0].headers.length}>
                                                <div className='no_table_data_found'>
                                                    <p>No Data Found.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </Fragment>
                            )}
                        </tbody>
                    </Table>
                </div>
                <Row className="align-items-center g-3 text-center text-sm-start pagination_wrap">
                    <div className="col-sm">
                        <div className='pagination_left_text'>Showing<span className="fw-normal ms-1">{page.length}</span> of <span className="fw-normal">{totalEntries}</span> entries
                        </div>
                    </div>
                    <div className="col-sm-auto">
                        <div className='react_pagination_wrap'>
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="next"
                                onPageChange={(item) => { setCurrentPage(item.selected); gotoPage(item.selected) }}
                                pageRangeDisplayed={3}
                                pageCount={totalPages}
                                previousLabel="previous"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    </div>
                </Row>
            </div>
        </>
    )
}

export default ViewBidsTable
